class NumberInput {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-number="scope"]',
			minusBtn: '[data-number="minus"]',
			plusBtn: '[data-number="plus"]',
			input: '[data-number="input"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click.number-input', this.config.minusBtn, this.changeAmount.bind(this));
		this.$scope.on('click.number-input', this.config.plusBtn, this.changeAmount.bind(this));
	}

	changeAmount(e) {
		e.preventDefault();
		let $button = $(e.currentTarget);
		let isNegative = $button.is(this.config.minusBtn);
		let $input = $button.closest(this.config.scope).find(this.config.input);
		if ($input.is('input')) {
			$input[0][isNegative ? 'stepDown' : 'stepUp']();
			$input.trigger('change');
		}
	}
}

export default NumberInput;